export interface INofeshSelected {
    id_nofesh: number;
    id_reservation: number;
    isRegistedByOtherAmit: boolean;
    isTkufatIdkun: boolean;
    no_zakaut_check: number;
    shem_prati: string;
    shem_mishpacha: string;
    rishum_by_other_id: number;
    isNofshon: boolean;
    moed_rishum: Date;
    nofesh_type: number;
    is_hamtana: boolean;
    isReservationCompleted: boolean;
    isEditMode: boolean;
    mimush: number;
}


export class NofeshSelected implements INofeshSelected {
    id_nofesh: number;
    id_reservation: number;
    isRegistedByOtherAmit: boolean;
    isTkufatIdkun: boolean;
    no_zakaut_check: number;
    shem_prati: string;
    shem_mishpacha: string;
    rishum_by_other_id: number;
    isNofshon: boolean;
    moed_rishum: Date;
    nofesh_type: number;
    is_hamtana: boolean;
    isReservationCompleted: boolean;
    isEditMode: boolean;
    mimush: number;

    constructor() {
        this.id_nofesh = 0;
        this.id_reservation = 0;
        this.isRegistedByOtherAmit = false;
        this.isTkufatIdkun = false;
        this.no_zakaut_check = 0;
        this.shem_prati = null;
        this.shem_mishpacha = null;
        this.rishum_by_other_id = 0;
        this.isNofshon = false;
        this.moed_rishum = null;
        this.nofesh_type = 0;
        this.is_hamtana = false;
        this.isReservationCompleted = false;
        this.isEditMode = false;
    }
}